import React, { useEffect, useState } from 'react';
import { Typography, Paper, Box, Grid, CircularProgress } from '@mui/material';
import { Link } from 'react-router-dom';
import CategoryIcon from '@mui/icons-material/Category';
import PeopleIcon from '@mui/icons-material/People';
import PaymentsIcon from '@mui/icons-material/Payments';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import { getFirestore, collection, getDocs, query, where } from 'firebase/firestore';

import Payroleheader from './Payroleheader';

// Firestore database instance
const db = getFirestore();

const DashboardCard = ({ title, count, icon, color, link }) => (
  <Link to={link} style={{ textDecoration: 'none' }}>
    <Paper
      elevation={4}
      sx={{
        height: 130,
        borderRadius: 2,
        p: 2,
        backgroundColor: color,
        color: '#fff',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        transition: '0.3s',
        cursor: 'pointer',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: 6,
          opacity: 0.95,
        },
      }}
    >
      <Box>
        <Typography variant="subtitle1">{title}</Typography>
        <Typography variant="h5" fontWeight="bold">
          {count}
        </Typography>
      </Box>
      <Box
        sx={{
          fontSize: 50,
          backgroundColor: 'rgba(255,255,255,0.15)',
          borderRadius: 2,
          p: 1,
          height: 70,
          lineHeight: 1,
        }}
      >
        {icon}
      </Box>
    </Paper>
  </Link>
);

const Payrolehome = () => {
  const [data, setData] = useState({
    staffCategories: 0,
    staffDetails: 0,
    monthlyPayment: 0,
    advancePayment: 0,
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const now = new Date();
        const currentYear = now.getFullYear().toString();
        const currentMonth = (now.getMonth() + 1).toString().padStart(2, '0');

        // Fetch staff categories count
        const categoriesSnap = await getDocs(collection(db, 'staffcategories'));
        const staffCategories = categoriesSnap.docs.length;

        // Fetch staff details count
        const detailsSnap = await getDocs(collection(db, 'staffdetails'));
        const staffDetails = detailsSnap.docs.length;

        // Fetch monthly payments for the current month
        const paymentsQuery = query(
          collection(db, 'staffpayments'),
          where('year', '==', currentYear),
          where('month', '==', currentMonth)
        );
        const paymentsSnap = await getDocs(paymentsQuery);
        let monthlyPayment = 0;
        paymentsSnap.forEach((doc) => {
          monthlyPayment += parseFloat(doc.data().paidSalary) || 0;
        });

        // Fetch advance payments for the current month
        const advancesQuery = query(
          collection(db, 'staffadvance'),
          where('year', '==', currentYear),
          where('month', '==', currentMonth)
        );
        const advancesSnap = await getDocs(advancesQuery);
        let advancePayment = 0;
        advancesSnap.forEach((doc) => {
          advancePayment += parseFloat(doc.data().advanceamount) || 0;
        });

        setData({
          staffCategories,
          staffDetails,
          monthlyPayment,
          advancePayment,
        });
      } catch (error) {
        console.error('Error fetching dashboard data:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box>
      <Payroleheader />
      <Typography variant="h5" gutterBottom>
        <b> कर्मचारी डॅशबोर्ड </b>
      </Typography>
      <Grid className="row">
        {/* Staff Category */}
        <Grid className="col-sm-3 mt-3" item xs={12} sm={6} md={3}>
          <DashboardCard
            title="कर्मचारी श्रेणी"
            count={data.staffCategories}
            icon={<CategoryIcon fontSize="inherit" />}
            color="#1976d2"
          // link="/staff/category"
          />
        </Grid>

        {/* Staff Details */}
        <Grid className="col-sm-3 mt-3" item xs={12} sm={6} md={3}>
          <DashboardCard
            title="कर्मचारी तपशील"
            count={data.staffDetails}
            icon={<PeopleIcon fontSize="inherit" />}
            color="#6a1b9a"
          // link="/staff/details"
          />
        </Grid>

        {/* Staff Advance Payment */}
        <Grid className="col-sm-3 mt-3" item xs={12} sm={6} md={3}>
          <DashboardCard
            title="उचल पगार"
            count={`₹${data.advancePayment.toLocaleString()}`}
            icon={<RequestQuoteIcon fontSize="inherit" />}
            color="#0288d1"
          // link="/staff/advance-payment"
          />
        </Grid>

        {/* Staff Monthly Payment */}
        <Grid className="col-sm-3 mt-3" item xs={12} sm={6} md={3}>
          <DashboardCard
            title="मासिक पगार"
            count={`₹${data.monthlyPayment.toLocaleString()}`}
            icon={<PaymentsIcon fontSize="inherit" />}
            color="#2e7d32"
          // link="/staff/monthly-payment"
          />
        </Grid>
      </Grid>
    </Box>

  );
};

export default Payrolehome;